import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@utils/route.utils.ts';
import Products from '@modules/products/products.tsx';
import ProductCategories from '@modules/product-categories/product-categories.tsx';
import Services from '@modules/services/services.tsx';

const CatalogComponent = lazy(() => import('./catalog.tsx'));

export const catalogRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <CatalogComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.Catalog.ProductCategories.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.Catalog.ProductCategories.path,
        element: <ProductCategories />
      },
      {
        path: RoutePaths.Core.Catalog.Products.path,
        element: <Products />
      },
      {
        path: RoutePaths.Core.Catalog.Services.path,
        element: <Services />
      }
    ]
  }
];
